'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var REQUEST_ACTION = exports.REQUEST_ACTION = '__REQUEST_ACTION';
var ADD_TO_REQUEST_STACK = exports.ADD_TO_REQUEST_STACK = 'ADD_TO_REQUEST_STACK';

// Action
function callApi(url, action) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    return {
        type: REQUEST_ACTION, payload: {
            url: url,
            action: action,
            options: data
        }
    };
};

function getApi(url, action) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    data.method = 'get';
    return callApi(url, action, data);
}
function postApi(url, action) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    data.method = 'post';
    return callApi(url, action, data);
}
function putApi(url, action) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    data.method = 'put';
    return callApi(url, action, data);
}
function deleteApi(url, action) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    data.method = 'delete';
    return callApi(url, action, data);
}
function patchApi(url, action) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    data.method = 'patch';
    return callApi(url, action, data);
}

exports.callApi = callApi;
exports.getApi = getApi;
exports.postApi = postApi;
exports.putApi = putApi;
exports.deleteApi = deleteApi;
exports.patchApi = patchApi;
//# sourceMappingURL=requests.js.map


//////////////////
// WEBPACK FOOTER
// ./~/perx-uikit/dist/actions/requests.js
// module id = 175
// module chunks = 5